export default "__VITE_ASSET__DO4Cb5lN__"